import { getPositionSourceName } from "react/utils/coordinateUtils";

/**
 * Classe responsável por desenhar coordenadas no mapa
 * Created by adalto on 5/13/14.
 */
Greenmile.Coordinates = Greenmile.Coordinates || {};

Greenmile.Coordinates.GeneralFunctions = function (sourceData) {

    const resources = Monet.I18n;

    this.screen = sourceData;

    const formatSpeed = function (speedInKm) {

        const unitSystem = Monet.Session.User.unitSystem;
        let unitSystemStr = resources.getResourcesByKey("Greenmile.UnitMetrics.kilometersPerHour");
        let result = 0;

        const formatter = new Monet.Format.DISTANCE(speedInKm);

        if (speedInKm) {
            if (unitSystem === "NON_METRIC") {
                result = formatter.convertKmToMiles().format().getValue();
            } else {
                result = speedInKm.toFixed(2);
            }
        }

        if (unitSystem === "NON_METRIC") {
            unitSystemStr = resources.getResourcesByKey("Greenmile.UnitMetrics.milesPerHour");
        }

        return result + " " + unitSystemStr;
    };

    this.getCoordPopupTemplate = function (info) {

        const container = document.createElement('div');
        const speed = document.createElement('div');
        const speedLabel = document.createElement('div');
        const speedContent = document.createElement('div');
        const time = document.createElement('div');
        const timeLabel = document.createElement('div');
        const timeContent = document.createElement('div');

        container.className = "routeDetail popupCoordinate";
        speed.className = "routeDetailItem";
        time.className = "routeDetailItem";
        speedLabel.className = 'label';
        timeLabel.className = 'label';
        speedContent.className = 'content';
        timeContent.className = 'content';

        speedLabel.innerHTML = Monet.I18n.getResourcesByKey('RouteDetail.PopUp.speed');
        timeLabel.innerHTML = Monet.I18n.getResourcesByKey('RouteDetail.PopUp.timeCoord');
        speedContent.innerHTML = info.speed;
        timeContent.innerHTML = info.date;

        speed.appendChild(speedLabel);
        speed.appendChild(speedContent);
        time.appendChild(timeLabel);
        time.appendChild(timeContent);

        container.appendChild(speed);
        container.appendChild(time);

        if (info.positionSource) {
          const positionSourceDiv = document.createElement('div');
          const positionSourceLabel = document.createElement('div');
          const positionSourceContent = document.createElement('div');

          positionSourceLabel.className = 'label';
          positionSourceLabel.innerHTML = Monet.I18n.getResourcesByKey(
            'position.source.label'
          );
          
          positionSourceContent.className = 'content';
          positionSourceContent.innerHTML = info.positionSource;
          positionSourceContent.title = info.positionSource;
          
          positionSourceDiv.className = 'routeDetailItem';
          positionSourceDiv.appendChild(positionSourceLabel);
          positionSourceDiv.appendChild(positionSourceContent);
          container.appendChild(positionSourceDiv);
        }

        return container;
    };

    this.renderPopUpTemplate = function ({ date, speedKmh , positionSource }) {
      return this.getCoordPopupTemplate({
        date: date ? Monet.Format.DateTime.formatToLocale(date) : '',
        speed: speedKmh ? formatSpeed(speedKmh) : '',
        positionSource: getPositionSourceName(positionSource)
      }).outerHTML;
    };

    this.coordsToPixels = function (map) {
      const mapBrounds = map.getBounds();

      const latTela0 = mapBrounds._northEast.lat;
      const lonTela0 = mapBrounds._northEast.lng;

      const latTela1 = mapBrounds._southWest.lat;
      const lonTela1 = mapBrounds._southWest.lng;

      const imageWidth = map.getSize().x;
      const imageheight = map.getSize().y;

      const xScale = imageWidth / Math.abs(lonTela0 - lonTela1);
      const yScale = imageheight / Math.abs(latTela0 - latTela1);

      return {
        x: xScale,
        y: yScale
      };
    };

    this.getCoordinatesDistanceInPixels = function (
      map,
      actualCoordinate,
      nextCoordinate
    ) {
      const scale = this.coordsToPixels(map);

      const actualLatitude = actualCoordinate.get('position').latitude;
      const actualLongitude = actualCoordinate.get('position').longitude;

      const nextLatitude = nextCoordinate.get('position').latitude;
      const nextLongitude = nextCoordinate.get('position').longitude;

      const pixelDistance = Math.sqrt(
        Math.pow((actualLatitude - nextLatitude) * scale.y, 2) +
          Math.pow((actualLongitude - nextLongitude) * scale.x, 2)
      );

      return parseInt(pixelDistance, 10);
    };

    this.getCoordinateDirection = function (coordinate1, coordinate2) {

        const radian = Math.atan2(coordinate1.latitude - coordinate2.latitude, coordinate1.longitude - coordinate2.longitude);
        const pi = Math.PI;
        const degree = radian * (180 / pi);

        return degree * -1;

    };

    this.createArrowMarker = function (
      coordinate,
      degree,
      arrowColor,
      eventToClick,
      map,
      equipmentId
    ) {
      const position = [
        coordinate.position.latitude,
        coordinate.position.longitude
      ];

      const templateRendered = this.renderPopUpTemplate(
        coordinate
      );
      const angle = degree - 138;
      const rotate = `rotate(${angle}deg)`;

      const markerDiv = document.createElement('div');
      markerDiv.className = 'coordinate-css fa fa-location-arrow';
      markerDiv.style.transform = rotate;
      markerDiv.style['-webkit-transform'] = rotate;
      markerDiv.style['-moz-transform'] = rotate;
      markerDiv.style['-ms-transform'] = rotate;
      markerDiv.style.color = arrowColor.border;

      const icon = L.divIcon({
        className: 'coordinate-arrow',
        html: markerDiv.outerHTML
      });

      const arrow = L.marker(position, { icon: icon });

      arrow.idCoordinate = coordinate.id.inc || coordinate.id;
      coordinate.equipmentId = equipmentId;
      arrow.coordinate = coordinate;
      arrow.kind = `ARROW_${equipmentId}`;

      const popup = L.popup({ maxWidth: 500, offset: new L.Point(38, 10) });
      const screen = Monet.Session.RouteDetail.screensList[map.routeId];

      const coordinateDistanceToolbar =
        new Greenmile.Toolbar.Map.DistanceBetweenCoords(
          screen?.tabSelector,
          map,
          { sourceSessionData: screen }
        )

        arrow.on('click', function (e) {
          if (!map.coordsDistance) {
            popup.setLatLng(position).setContent(templateRendered).openOn(map);
            return;
          }

          screen
            ? coordinateDistanceToolbar.markerClickHandler(e)
            : eventToClick(e);
        });


      return arrow;
    };

    this.coordinatesAreEqual = function (coord1, coord2) {
      return (coord1.latitude == coord2.latitude &&
              coord1.longitude == coord2.longitude);
    };

    this.getDistanceByZoomLevel = function (zoom) {
        let distance;

        switch (zoom) {
          case 22:
          case 21:
          case 20:
          case 19:
          case 18:
          case 17:
          case 16:
            distance = 0;
            break;
          case 15:
            distance = 2;
            break;
          case 14:
            distance = 4;
            break;
          case 13:
            distance = 6;
            break;
          case 12:
            distance = 8;
            break;
          default:
            distance = 8;
        }

        return distance;

    }

    this.drawLayerWithArrows = function (map, coordinatesCollection, options, equipmentId) {
      const coords = [];
      const zoom = map.getZoom();
      const arrowsAndLineGroup = L.layerGroup();
      const coordinates = coordinatesCollection || [];
      const distanceByZoom = this.getDistanceByZoomLevel(zoom);
      let lastArrowCoordnate = null;
      let color = '#FF0000';
      let kind = '';

      if (options) {
          color = options.color || color;
          kind = options.kind || kind;
      }

      const bounds = map.getBounds();
      const expandedBounds = bounds.pad(1);
      coordinates.forEach((actualCoordinate, i) => {
        const { latitude, longitude } = actualCoordinate.get('position');
        const inBounds = expandedBounds.contains([latitude, longitude]);
        const coordsDistanceInPixel = lastArrowCoordnate
          ? this.getCoordinatesDistanceInPixels(
              map,
              lastArrowCoordnate,
              coordinates.at(i - 1)
            )
          : 0;
        const currentPosition = { latitude, longitude };
        const shouldRenderArrow =
          inBounds &&
          (!lastArrowCoordnate || coordsDistanceInPixel >= distanceByZoom);
        if (shouldRenderArrow) {
          let degrees = 90;
          lastArrowCoordnate = actualCoordinate;
          for (let j = i + 1; j < coordinates.size(); j++) {
            const next = coordinates.at(j);
            const nextPosition = next.get('position');
            const coordsAreEqual = this.coordinatesAreEqual(
              nextPosition,
              currentPosition
            );

            if (!coordsAreEqual) {
              degrees = this.getCoordinateDirection(
                currentPosition,
                nextPosition
              );
              break;
            }
          }

          const arrow = this.createArrowMarker(
            actualCoordinate.attributes,
            degrees,
            actualCoordinate.color(),
            options.eventToClickArrow,
            map,
            equipmentId
          );

          if (kind === 'ACTUAL_ROUTE') {
            this.screen.actualMarkers[arrow.idCoordinate] = arrow;
          }

          if (this.screen.equipments) {
            this.screen.equipments[equipmentId].arrows =
              this.screen.equipments[equipmentId].arrows || {};
            this.screen.equipments[equipmentId].arrows[arrow.idCoordinate] =
              arrow;
          }
          arrowsAndLineGroup.addLayer(arrow);
        }

        coords.push([latitude, longitude]);
      });

      const lines = L.polyline(coords, { color, positionSource: options?.source });
      if (kind) {
          lines.kind = kind;
      }
      arrowsAndLineGroup.addTo(map);
      lines.addTo(map);
      lines.bringToFront();
  };

    this.generateActualRouteInfo = function (map, coordinates, options, equipmentId) {
      if (this.screen.canShowLayerCoordinates && coordinates?.size()) {
        if (map.target) {
          map = map.target;
        }
        map.eachLayer(function (layer) {
          const kind = layer.kind;

          if (`ARROW_${equipmentId}` === kind) {
            map.removeLayer(layer);
          }
        });
        this.drawLayerWithArrows(map, coordinates, options, equipmentId);
      }

      this.checkIfHasCoordinates(coordinates);
    };

    this.checkIfHasCoordinates = function (coords) {
        const value = (coords?.size()) ? "none" : "block";

        $(`#${Monet.Utils.GetTabName()} .noTackInfo`).css("display", value);
    };

    this.requestCoordinateByEquipment = function (equipmentId, beginDateInMilliSeconds, endDateInMilliSeconds, callback) {
        const bodyData = {};
        const endDate = new Date(endDateInMilliSeconds).getTime();
        const ONE_MINUTE = 1000 * 60;

        bodyData.equipmentId = equipmentId;
        bodyData.beginDate = Monet.Format.DateTime.formatToISOString(beginDateInMilliSeconds);
        bodyData.endDate = Monet.Format.DateTime.formatToISOString(new Date(endDate + ONE_MINUTE));

        if (equipmentId) {
            const loading = new Monet.UI.LoadingData();
            loading.init();
            loading.show();

            const ajax = new Monet.Ajax();
            ajax.url = "Coordinate/ActualPathByEquipment";
            ajax.method = 'post';
            ajax.data = bodyData;
            ajax.success = function (data) {
              loading.hide();
              if (data) {
                const positionSources = new App.Collections.PositionSources();
                positionSources.add(data);
                positionSources.sortBySourceType();
                if (callback) {
                    callback(equipmentId, positionSources);
                }
              }
            };
            ajax.error = function (xhr) {
                loading.hide();
                Monet.Configurations.errorNotification(null, xhr);
            };
            ajax.send();
        }
    };

    this.getRadiusByZoomLevel = function (zoom) {
        let radius;

        switch (zoom) {
            case 18:
                radius = 4;
                break;
            case 17:
                radius = 7;
                break;
            case 16:
                radius = 14;
                break;
            case 15:
                radius = 30;
                break;
            case 14:
                radius = 60;
                break;
            case 13:
                radius = 100;
                break;
            case 12:
                radius = 130;
                break;
            case 11:
                radius = 300;
                break;
            case 10:
                radius = 400;
                break;
            default:
                radius = 300;
        }

        return radius;

    };

    this.isLatitude = latitude => {
        return isFinite(latitude) && Math.abs(latitude) <= 90;
    };

    this.isLongitude = longitude => {
        return isFinite(longitude) && Math.abs(longitude) <= 180;
    };
};
